import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

import { withFormStyles } from '../styles';

const InputError = withFormStyles(({ classes, children }) => (
    <Typography component="div" className={classes.formInputError}>
        {children}
    </Typography>
));

class MasterPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.init();
    }

    init() {
        const [days, password] = this.props.policy.value.policy
            .split(',')
            .map(s => Number(s));
        return {
            days,
            password,
            daysError: false,
            passwordError: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.policy.value.policy !== this.props.policy.value.policy) {
            this.setState(this.init());
        }
        if (!this.props.enabled && prevProps.enabled !== this.props.enabled) {
            this.setState(this.init());
        }
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleCancel = event => {
        this.setState(this.init());
    };

    handleSave = event => {
        this.setState(
            (state, props) => {
                return {
                    daysError: state.days < 30,
                    passwordError: state.password < 1,
                };
            },
            () => {
                if (!this.state.daysError && !this.state.passwordError) {
                    const value = `${this.state.days}, ${this.state.password}`;
                    const data = {
                        uuid: this.props.policy.uuid,
                        value: value,
                        enabled: true,
                    };
                    this.props.onSave(data);
                }
            }
        );
    };
    render() {
        const { classes, enabled, editable } = this.props;
        const disabled = !enabled || !editable;

        return (
            <>
                <div className={classes.masterPasswordForm}>
                    <TextField
                        type="number"
                        label="Master Password expiration"
                        disabled={disabled}
                        value={this.state.days}
                        onChange={this.handleChange('days')}
                        className={classes.root}
                        error={this.state.daysError}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    days
                                </InputAdornment>
                            ),
                        }}
                        style={{ paddingBottom: '10px' }}
                    />
                    {this.state.daysError && (
                        <InputError>
                            Expiration should be greater than or equal to 30
                        </InputError>
                    )}
                    <TextField
                        type="number"
                        label="Prevent reuse of previous passwords"
                        disabled={disabled}
                        value={this.state.password}
                        onChange={this.handleChange('password')}
                        className={classes.root}
                        error={this.state.passwordError}
                    />
                </div>
                <div>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleSave}
                    >
                        Save
                    </Button>
                </div>
            </>
        );
    }
}

export default withFormStyles(MasterPasswordForm);
